export default __webpack_public_path__ + "static/media/support.a18652ef.svg";